<template>
  <div class="flex flex-col lg:w-full md:w-auto sm:w-auto mx-4 py-8 text-center bg-white border-2 border-gray-200 rounded-lg dark:bg-gray-800 dark:border-gray-700 tiktok-plan-A" style="height:385px;">
    <div class="text-center">
        <h2 class="font-semibold uppercase tiktok-plan-A-title">
          {{ plansListAData.plan_a_title }}
        </h2>
        <!-- <span class="text-gray-500">適合初階使用者</span> -->
    </div>
    <div class="text-gray-700 text-center font-mono flex flex-wrap justify-center content-center py-4 my-4 bg-tiktok-plan-A">
      <div class="text-white">
        <p class="text-3xl">${{ plansListAData.plan_a_label_amount }}<span class="text-sm ml-2">/{{lang['components']['Plan']['PlanA']['time_unit']}}</span></p>
        <p v-if="false" class="text-sm">per month</p>
      </div>
    </div>
    <ul class="flex-1 space-y-2 text-gray-500 dark:text-gray-400">
      <li v-for="(item, index) in description" class="border-b">
          {{ item }}
      </li>
    </ul>
    <!--<button v-if="plansListAData.plan_a_show" class="rounded-full bg-tiktok-plan-A mx-16 py-2 mt-12" :disabled="isDisabled" @click="handleChickPlan(2, 'A')">
      {{ plansListAData.plan_a_text }}
    </button>-->
    <button v-if="plansListAData.plan_a_show" class="rounded-full bg-tiktok-plan-A mx-16 py-2 mt-12" @click="tiktokHandleChickPlan(2, 'A', '', 'tiktok')">
      {{ plansListAData.plan_a_text }}
    </button>
    <button v-else-if="!plansListAData.planHaveBind" class="rounded-full bg-tiktok-plan-A mx-16 py-2 mt-12" @click="tiktokHandleChickPlan(2, 'A', '', 'tiktok')">
      {{lang['components']['Plan']['PlanA']['is_expired']}}
    </button>
    <button
      v-else
      class="rounded-full bg-red-500 mx-16 py-2 mt-12"
       v-if="isExpiredData && (plansListAData.plan_a_text == '使用中' || plansListAData.plan_a_text == 'Using')"
      @click="tiktokHandleChickPlan(2, 'A', 'payAgain', 'tiktok')"
    >
      {{lang['components']['Plan']['PlanA']['plan_item_payagain_button_text']}}
    </button>
  </div>
</template>

<script>
export default {
  name: 'PlanA',
  props: {
    tiktokHandleChickPlan: {
      type: Function,
      default: () => ({})
    },
    plansListA:{
      type:Object,
      required:true
    },
    isExpired: {
      type: Boolean
    },
    lang: {
      type: Object
    },
  },
  computed: {
    plansListAData: {
      get: function () {
        return this.plansListA
      },
      set: function (value) {
        this.$emit('update:plansListAData', value)
      },
    },
    isExpiredData: {
      get: function () {
        return this.isExpired
      },
      set: function (value) {
        this.$emit('update:isExpiredData', value)
      },
    },
    description: function() {
       return this.plansListA.plan_a_description
    },
    isDisabled: function() {
       return this.plansListA.plan_a_disable
    }
  }
}
</script>

<style lang="scss" scope>
  .tiktok-plan-A {
    &:hover {
      border: 2px #210318 solid;
    }
  }
</style>